import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import Onboarding from './templates/organisms/onboarding';

loadWidget('.plf-onboarding-area', onboardingWidget => {
    const actionURL = onboardingWidget.dataset.url;
    const agbText = onboardingWidget.dataset.agbText;
    const swissIdEmail = onboardingWidget.dataset.swissIdEmail;
    const swissIdEmailUrl= onboardingWidget.dataset.swissIdEmailUrl;
    const supportFormLink = onboardingWidget.dataset.linkSupportForm;
    const homepageLinkAction = onboardingWidget.dataset.homepageLinkAction;
    const linkAccessDataForm = onboardingWidget.dataset.linkAccessDataForm;
    const linkChangeSwissIdEmail = onboardingWidget.dataset.linkChangeSwissIdEmail;

    ReactDOM.render(<Onboarding actionUrl={actionURL} agbText={agbText} swissIdEmail={swissIdEmail} swissIdEmailUrl={swissIdEmailUrl} supportFormLink={supportFormLink} homepageLinkAction={homepageLinkAction} linkAccessDataForm={linkAccessDataForm} linkChangeSwissIdEmail={linkChangeSwissIdEmail} />, onboardingWidget);
});
